var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section',{staticClass:"section-articles-popular-list",attrs:{"title":_vm.$t('PORTAL.SECTION.ARTICLES.POPULAR.TITLE')}},[(_vm.isLoading)?_c('base-loader'):_c('section-parts-article-populars-list',{attrs:{"list":_vm.getList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }